import React from 'react';
import { DialogActions } from '@mui/material';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import SimulationDoneFrozen from '../../../../../../../../../common/SimulationDoneFrozen';
import InforPreview from '../../../../../../../../../common/InforPreview';

const ShoppingCartFactoringQuoted = (props: any) => {
  const { setOpenShoppingcart, selectedRequest, setOpenRequest, setUp } = props;

  const infoDiv = (
    <InforPreview
      requestType="factoring"
      type="Sent"
      status="Aceptada"
      selectedRequest={selectedRequest}
      setSelectedRequest={setOpenRequest}
      setUp={setUp}
    />
  );

  return (
    <div>
      <div>
        <SimulationDoneFrozen
          selectedRequest={selectedRequest}
          infoDiv={infoDiv}
        />
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingcart(false)}
            color="secondary"
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    </div>
  );
};

export default ShoppingCartFactoringQuoted;
